module.exports = __webpack_public_path__ + "static/img/page03_person.81d114b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page03_person.png
// module id = CUI9
// module chunks = 1